import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { RestService } from "../services/rest.service";
import { PromotionImagesService } from "../services/promotion-images.service";
import { currentPromotion } from "../tools/tools";
import { CotizacionMain } from "../interfaces/main-cotizacion.interface";
import {
  CostFleteForeign,
  Cotizacion,
} from "../interfaces/CotizacionV2/CotizacionV2.interface";
import { CotizacionV1 } from "../interfaces/CotizacionesV1/CotizacionV1.interface";

@Component({
  selector: "app-viewer",
  templateUrl: "./viewer.component.html",
  styleUrls: ["./viewer.component.css"],
})
export class ViewerComponent implements OnInit {
  preOrder: CotizacionMain;
  orderContent: CotizacionV1;
  orderContentNuevo: Cotizacion;
  costFleteForeign: CostFleteForeign = new CostFleteForeign();

  credit: boolean;
  cash: boolean;
  vNotAv: boolean;
  vLoading: boolean;
  separated: boolean;
  folio: string;
  origin: number;
  ytSrc = "NA";
  browser: string = window.navigator.userAgent;
  cargando = false;
  errorCarga = false;

  noteCostFleteForeign = "";

  nombre: string;
  primerApellido: string;
  segundoApellido: string;

  constructor(
    private router: ActivatedRoute,
    public restService: RestService,
    public promotionImages: PromotionImagesService
  ) {}

  get activePromotionName(): string | null {
    return currentPromotion.isActive ? currentPromotion.name : null;
  }

  ngOnInit() {
    this.init();
  }
  init() {
    this.cargando = true;
    this.errorCarga = false;
    this.folio = this.router.snapshot.paramMap.get("folio");
    this.origin = parseInt(this.router.snapshot.paramMap.get("origin"));

    this.restService.originConsulta = this.origin;
    this.restService.folio = this.folio;

    let strAction = "NA";
    // console.log(this.router.snapshot.paramMap);

    if (this.origin === 1) {
      strAction = "openFromMAIL";
    } else {
      strAction = "openFromSMS";
    }
    const action =
      '{ "idLandingPage": 8, ' +
      '"idToken": -1, ' +
      '"folioCotizacion": "' +
      this.folio +
      '", ' +
      '"idAccionLandingPage": -1, ' +
      '"ip": "0.0.0.0", ' +
      '"navegador": "' +
      this.browser +
      '", ' +
      '"accion": "' +
      strAction +
      '", ' +
      '"validacionUsuario": false, ' +
      '"idOrigen": 17, ' +
      '"agente": -1 }';

    this.restService.fetchPreOrder(this.folio).subscribe(
      async (result) => {
        try {
          // console.log(result);
          this.preOrder = result;
          console.log('precioFlete:', this.preOrder.precioFlete);

          // console.log('FECHA PREORDEN -> ', this.preOrder.fecha)

          // esCotizacionHotSale(this.preOrder.fecha);
          // console.log('JSON', JSON.stringify(result.json));
          // console.log(this.preOrder.nuevo);

          // console.log(this.preOrder);
          this.restService.setMes(result.fecha);

          if (this.preOrder.nuevo) {
            this.orderContentNuevo = JSON.parse(this.preOrder.json);
            // console.log("orderContentNuevo");
            // console.log(this.orderContentNuevo);

            // Get cost flete foreign
            this.getCostFleteForeign(this.orderContentNuevo.zoneId.toString());

            this.nombre = this.orderContentNuevo.firstName === "NA" ? "" : this.orderContentNuevo.firstName;
            this.primerApellido = this.orderContentNuevo.lastName === "NA" ? "" : this.orderContentNuevo.lastName;
            this.segundoApellido = this.orderContentNuevo.secondLastName === "NA" ? "" : this.orderContentNuevo.secondLastName;

            this.orderContentNuevo.cartItems.forEach(async (item) => {
              item.video = await this.getVideo(item.sku);
              // console.log(item.video);
            });
          } else {
            this.orderContent = JSON.parse(result.json);
            // console.log("orderContent");
            // console.log(result.json);
            this.nombre = this.orderContent.nombres === "NA" ? "" : this.orderContent.nombres;
            this.primerApellido = this.orderContent.apellidoA === "NA" ? "" : this.orderContent.apellidoA;
            this.segundoApellido = this.orderContent.apellidoB === "NA" ? "" : this.orderContent.apellidoB;

            this.orderContent.cartItems.forEach(
              async (item) => (item.video = await this.getVideo(item.sku))
            );

            // console.log(this.orderContent.cartItems);
          }
          this.cargando = false;
        } catch (error) {
          this.cargando = false;

          // console.error(error);
        }
      },
      (err) => {
        this.cargando = false;

        this.errorCarga = true;
        // console.log(err);
      }
    );

    this.restService.sendAction(JSON.parse(action)).subscribe((result) => {});
  }

  async getCostFleteForeign(zoneId: String) {
    const obj = {
      zona: zoneId,
      cedis: "",
    };

    this.restService.fetchCostFleteForeign(obj).subscribe(
      (result) => {
        // console.log(result);
        this.costFleteForeign = result;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  async getVideo(sku: string) {
    return new Promise<string>((resolve, reject) => {
      this.restService.fetchVideo(sku).subscribe(
        (result) => {
          // console.log(result);
          if (result != null && result.url !== "NA") {
            // console.log('PASO', result);
            resolve(result.url);
          } else {
            resolve("NA");
          }
        },
        (err) => {
          resolve("NA");
        }
      );
    });
  }

  containtMotocicleta(): boolean {
    var flag = false;
    // this.cotizacion.cartItems.forEach((element) => {
    //   if (element.line.toLowerCase().includes("motocicleta".toLowerCase())) {
    //     return (flag = true);
    //   }
    // });

    this.orderContentNuevo.cartItems.forEach((element) => {
      // console.log("Línea del producto:", element.line);
      if (element.line.toLowerCase().includes("motocicleta".toLowerCase())) {
        return (flag = true);
      }
    });

    return flag;
  }
  containtCelular(): boolean {
    var flag = false;

    this.orderContentNuevo.cartItems.forEach((element) => {
      if (element.line.toLowerCase().includes("celular".toLowerCase())) {
        return (flag = true);
      }
    });

    return flag;
  }

  hasItemWithFlete(): boolean {
    if (!this.orderContentNuevo?.cartItems) return true;
    return this.orderContentNuevo.cartItems.some(
      (element) =>
        !element.line.toLowerCase().includes("motocicleta") &&
        !element.line.toLowerCase().includes("celular")
    );
  }

  // showPriceFlete(): boolean {
  //   if (this.preOrder?.precioFlete > 0) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
}
